import React, { useState, useRef, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Container, Modal } from 'react-bootstrap'
import { Row, Col } from 'antd'
import '@wartek-id/design-tokens/build/guru-desktop/css/color.css'
import Slider from 'react-slick'
import { InputGroup, InputLeftAddon, Input } from '@wartek-id/input'
import { Button } from '@wartek-id/button'
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleIcon,
  CollapsibleTrigger,
} from '@wartek-id/collapsible'
import { useInView } from 'react-intersection-observer'
import config from 'app/config'

const SatuanPendidikans = ({ clickVideo, clickHelpCenter, typeSearchKeyword, searchSubmit }) => {
  const imageRef = useRef(null)
  const [keyword, setKeyword] = useState('')
  const [isVideoOpen, setIsVideoOpen] = useState(false)
  const [userPos, setUserPos] = useState({ lat: null, long: null })
  const geolocationAPI = navigator.geolocation

  useEffect(() => {
    geolocationAPI.getCurrentPosition(
      (pos) => {
        const newUserPos = {
          lat: pos.coords.latitude,
          long: pos.coords.longitude,
        }
        setUserPos(newUserPos)
      },
      (err) => {
        console.log(err)
      },
    )
  }, [])

  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '10px',
    arrows: true,
    className: 'slider variable-width',
    variableWidth: true,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  }

  const onFormSubmit = (e) => {
    e.preventDefault()
    searchSubmit(keyword)
    if(userPos?.lat !== null && userPos?.long !== null){
      window.open(
        `${config.search_url}?keyword=${keyword}&latitude=${userPos?.lat}&longitude=${userPos?.long}&sort=RELEVANCE`,
        '_blank',
      )
    }else{
      window.open(
        `${config.search_url}?keyword=${keyword}&sort=RELEVANCE`,
        '_blank',
      )
    }
  }

  const searchItem = (item) => {
    searchSubmit(item)
    if(userPos?.lat !== null && userPos?.long !== null){
      window.open(
        `${config.search_url}?keyword=${item}&latitude=${userPos?.lat}&longitude=${userPos?.long}&sort=RELEVANCE`,
        '_blank',
      )
    }else{
      window.open(
        `${config.search_url}?keyword=${item}&sort=RELEVANCE`,
        '_blank',
      )
    }
  }

  const handleClickVideo = () => {
    setIsVideoOpen(true)
    clickVideo()
  }

  const handleClickHelpCenter = () => {
    clickHelpCenter()
  }

  const handleTypeSearchKeyword = () => {
    typeSearchKeyword()
  }

  const [collapse, setCollapse] = useState([
    {
      id: 1,
      open: false,
      title: 'Apa manfaat SIPLah bagi satuan pendidikan?',
      content:
        'Dengan SIPLah, satuan pendidikan dapat berbelanja kebutuhan sekolah secara daring, transparan, dan aman karena dilengkapi dengan dokumen yang mendukung pelaporan dana BOS.',
    },
    {
      id: 2,
      open: false,
      title: 'Kapan waktu yang tepat untuk menggunakan SIPLah?',
      content:
        'Waktu yang tepat untuk menggunakan SIPLah adalah ketika Satuan Pendidikan membutuhkan barang pra katalog, barang umum, maupun jasa untuk memenuhi kebutuhan di sekolahnya.',
    },
    {
      id: 3,
      open: false,
      title: 'Bagaimana cara mengakses SIPLah?',
      content:
        'SIPLah dapat diakses pada alamat web <a href="https://siplah.kemendikdasmen.go.id/#mitra" target="_blank">https://siplah.kemendikdasmen.go.id/#mitra</a> dengan mencari barang dan memilih Mitra yang diinginkan. Untuk panduan mencari barang, silakan cek pada panduan berikut: <a href="https://pusatinformasi.siplah.kemendikdasmen.go.id/hc/en-gb/articles/7007479512985-Fitur-Pencarian-pada-SIPLah" target="_blank">Fitur Pencarian untuk Satuan Pendidikan</a>',
    },
    {
      id: 4,
      open: false,
      title: 'Bagaimana Jika Akun Bermasalah/ Gagal Login?',
      content:
        'Jika Anda mengalami kendala saat login ke Platform SIPLah melalui situs masing-masing Mitra anda dapat melakukan tahapan pada link berikut: <a href="https://bit.ly/GagalLoginSIPLah" target="_blank">https://bit.ly/GagalLoginSIPLah</a>',
    },
    {
      id: 5,
      open: false,
      title: 'Mengapa Sumber Dana Tidak Muncul?',
      content:
        'Sumber Dana Bantuan Operasional Pendidikan (BOP) pada SIPLah dapat dibuka apabila sudah terdapat konfirmasi penyaluran dari Kementerian. Apabila satuan pendidikan sudah menerima penyaluran, namun menu sumber dana belum terbuka dan sumber dana tidak muncul, silakan menginformasikan melalui email <a href="mailto:sds.siplah@kemendikdasmen.go.id">sds.siplah@kemendikdasmen.go.id</a> untuk diproses lebih lanjut oleh tim Kementerian',
    },
    {
      id: 6,
      open: false,
      title: 'Saya, sebagai operator PBJ satdik, sudah melakukan transaksi pada Mitra yang tidak melanjutkan kerja sama dengan SIPLah sebelum tanggal 1 September 2023, apa yang harus saya lakukan?',
      content:
        'Anda dapat menyelesaikan transaksi yang sedang berjalan sesuai dengan ketentuan yang tertera pada website masing-masing Mitra.',
    },
  ])

  const changeCollapse = (id) => {
    setCollapse(
      collapse.map((item) =>
        item.id === id ? { ...item, open: !item.open } : item,
      ),
    )
  }

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0,
  })

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0,
  })

  const { ref: thirdContainer, inView: thirdInView } = useInView({
    threshold: 0,
  })

  const { ref: fourthContainer, inView: fourthInView } = useInView({
    threshold: 0,
  })

  const { ref: fifthContainer, inView: fifthInView } = useInView({
    threshold: 0,
  })

  const getImage = () => {
    if (firstInView)
      return './assets/cara-kerja/img-satdik-mencari-dan-memilih.png'
    if (secondInView) return './assets/cara-kerja/img-satdik-membandingkan.png'
    if (thirdInView) return './assets/cara-kerja/img-satdik-membuat-pesanan.png'
    if (fourthInView)
      return './assets/cara-kerja/img-satdik-menerima-pesanan.png'
    if (fifthInView)
      return './assets/cara-kerja/img-satdik-melakukan-pembayaran.png'
    return './assets/cara-kerja/img-satdik-mencari-dan-memilih.png'
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Satuan Pendidikan | Situs Informasi SIPLah</title>
        <link rel="canonical" href="siplah.kemendikdasmen.go.id/satuan-pendidikan" />
        <meta http-equiv="Cache-control" content="max-age=31536000"></meta>
        <meta
          name="title"
          content="Satuan Pendidikan | Situs Informasi SIPLah"
        ></meta>
        <meta
          name="description"
          content="Cari tahu keuntungan dan cara berbelanja di SIPLah."
        ></meta>
      </Helmet>
      <div className="h-100">
        <section className="bg-dark-blue text-white overflow-x-hidden">
          <Container className="container-satdik">
            <Row gutter={[16, 16]}>
              <Col lg={14} md={20} sm={24} xs={24}>
                <div className="text-caption-header text-white-smoke m-b-24 gap-header-satdik-100">
                  <b>Satuan Pendidikan</b>
                </div>
                <h1 className="font-switzer-bold text-white text-header-satdik text-head-satdik">
                  <b className="font-light-bold">
                    Pengadaan barang dan jasa satuan pendidikan jadi lebih aman
                    dan praktis.
                  </b>
                </h1>
              </Col>
              <Col lg={10} md={24} sm={24} xs={24} className="text-right">
                <img
                  src="./assets/homepage/satdik-desktop.svg"
                  className="img-block d-none d-xl-block float-right"
                  alt="satdik-desktop"
                />
                <img
                  src="./assets/homepage/satdik-desktop.svg"
                  className="img-block d-none d-lg-block d-xl-none float-right"
                  alt="satdik-desktop"
                />
                <img
                  src="./assets/homepage/satdik-tablet.svg"
                  className="img-block d-none d-md-block d-lg-none"
                  alt="satdik-tablet"
                />
                <img
                  src="./assets/homepage/satdik-mobile.svg"
                  className="img-block d-none d-sm-block d-md-none"
                  alt="satdik-mobile"
                />
                <img
                  src="./assets/homepage/satdik-mobile.svg"
                  className="img-block d-block d-sm-none"
                  alt="satdik-mobile"
                />
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section-body-3">
          <Container>
            <div>
              <h2 className="font-switzer-semibold gap-text-header-64">
                <b>Keuntungan utama berbelanja di SIPLah</b>
              </h2>
              <Row gutter={[16, 16]}>
                <Col lg={8} md={12} sm={12} xs={24}>
                  <div className="width-328">
                    <img
                      src="./assets/homepage/berkas-administrasi-terdokumentasi.svg"
                      alt="satuan_pendidikan"
                      width="60"
                      className="m-t-20 m-b-24"
                    />
                    <div className="font-size-22 m-b-12">
                      <b>Berkas administrasi terdokumentasi di SIPLah</b>
                    </div>
                    <div className="grey-text font-size-16 m-b-10">
                      <i>Invoice</i>, bukti serah terima, dan dokumen keperluan
                      administrasi lainnya dapat ditemukan dan diunduh langsung
                      dari SIPLah.
                    </div>
                  </div>
                </Col>
                <Col lg={8} md={12} sm={12} xs={24}>
                  <div className="width-328">
                    <img
                      src="./assets/homepage/pajak-belanja.svg"
                      alt="satuan_pendidikan"
                      width="60"
                      className="m-t-20 m-b-24"
                    />
                    <div className="font-size-22 m-b-12 d-none d-md-block">
                      <b>
                        Pajak belanja
                        <br />
                        diurus SIPLah{' '}
                      </b>
                    </div>
                    <div className="font-size-22 m-b-12 d-none d-sm-block d-md-none">
                      <b>Pajak belanja diurus SIPLah </b>
                    </div>
                    <div className="font-size-22 m-b-12 d-block d-sm-none">
                      <b>Pajak belanja diurus SIPLah </b>
                    </div>
                    <div className="grey-text font-size-16 m-b-10">
                      Mitra pengelola pasar daring SIPLah akan memungut,
                      menyetor, dan melaporkan pajak ke DJP. Invoice belanja
                      juga berlaku sebagai bukti potong pajak yang sah.
                    </div>
                  </div>
                </Col>
                <Col lg={8} md={12} sm={12} xs={24}>
                  <div className="width-328">
                    <img
                      src="./assets/homepage/pembayaran-setelah-pesanan-datang.svg"
                      alt="satuan_pendidikan"
                      width="60"
                      className="m-t-20 m-b-24"
                    />
                    <div className="font-size-22 m-b-12">
                      <b>Pembayaran setelah pesanan datang</b>
                    </div>
                    <div className="grey-text font-size-16 m-b-10">
                      Satdik boleh membayar pesanan setelah menerima produk dan
                      memastikan kualitasnya sesuai spesifikasi.
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
        <hr />
        <section className="section-body-2">
          <Container>
            <h2 className="font-switzer-semibold m-b-24">
              <b>Kata mereka yang sudah berbelanja</b>
            </h2>
            <div className="font-size-20 satdik-text-container">
              Lebih dari <b>223.000 Satdik</b> telah merasakan kemudahan
              administrasi lewat berbelanja di SIPLah. Berikut beberapa
              pengalaman mereka.
            </div>
          </Container>
        </section>
        <section className="bg-dark-blue p-b-44 height-step-satdik">
          <Container className="align-items-center text-center">
            <div className="position-relative satdik-video-container">
              <div className="position-relative">
                <a onClick={() => handleClickVideo()}>
                  <span className="material-icons text-blue button-play-video-big">
                    play_circle_filled
                  </span>
                </a>
              </div>
              <div className="m-t-10 m-b-40">
                <img
                  src="./assets/homepage/satdik-video.png"
                  alt="play-video"
                  className="img-block img-darken"
                />
              </div>
              <div className="text-center text-satdik-video">
                <b className="font-size-27 text-white">
                  Testimonial Satuan Pendidikan
                </b>
                <div className="text-white">
                  Ketahui manfaat SIPLah langsung dari pengguna
                </div>
              </div>
            </div>
          </Container>
          <Container className="position-relative container-slider">
            <div className="position-relative satdik-slider-container slider-homepage">
              <Slider {...settings}>
                <div
                  className="why-use-siplah m-t-10 m-b-10 why-height"
                  style={{ width: 512 }}
                >
                  <div className="inside-quote">
                    <div>
                      <img
                        src="./assets/quotes/quotes-1.png"
                        alt="quotes"
                        width="27"
                        className="m-b-20"
                      />
                      <div className="font-size-22 m-b-30">
                        Di SIPLah bisa bayar di belakang. Jadi Satdik bisa{' '}
                        <span className="bg-light-orange">
                          memeriksa barang terlebih dahulu baru bayar
                        </span>{' '}
                        sehingga lebih merasa aman saat belanja.
                      </div>
                    </div>
                    <Row gutter={[16, 16]} className="align-items-center">
                      <Col
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        className="p-r-0 text-right"
                      >
                        <img
                          src="./assets/quotes/ava-satdik-1.jpeg"
                          alt="quotes"
                          className="img-quotes"
                        />
                      </Col>
                      <Col
                        lg={20}
                        md={18}
                        sm={18}
                        xs={18}
                        className="p-l-0 text-left"
                      >
                        <b>Ginanjar</b>
                        <div className="grey-text">
                          <b>
                            Pelaksana PBJ SDN Cikidang - Sukabumi - Satuan
                            Pendidikan
                          </b>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div
                  className="why-use-siplah m-t-10 m-b-10 why-height"
                  style={{ width: 512 }}
                >
                  <div className="inside-quote">
                    <div>
                      <img
                        src="./assets/quotes/quotes-3.png"
                        alt="quotes"
                        width="27"
                        className="m-b-20"
                      />
                      <div className="font-size-22 m-b-30">
                        Penggunaan SIPLah bisa dipelajari dengan mudah. SIPlah
                        menguntungkan untuk kami (sekolah di Kabupaten) karena{' '}
                        <span className="bg-light-orange">
                          pengiriman barang lebih cepat sampai
                        </span>{' '}
                        dari pada saat berbelanja di luar SIPLah.
                      </div>
                    </div>
                    <Row gutter={[16, 16]} className="align-items-center">
                      <Col
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        className="p-r-0 text-right"
                      >
                        <img
                          src="./assets/quotes/ava-satdik-2.jpg"
                          alt="quotes"
                          className="img-quotes"
                        />
                      </Col>
                      <Col
                        lg={20}
                        md={18}
                        sm={18}
                        xs={18}
                        className="p-l-0 text-left"
                      >
                        <b>Kornelis</b>
                        <div className="grey-text">
                          <b>
                            Pelaksana PBJ SMP Satu Atap YPPK Tanah Merah - Papua
                            - Satuan Pendidikan
                          </b>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div
                  className="why-use-siplah m-t-10 m-b-10 why-height"
                  style={{ width: 512 }}
                >
                  <div className="inside-quote">
                    <div>
                      <img
                        src="./assets/quotes/quotes-1.png"
                        alt="quotes"
                        width="27"
                        className="m-b-20"
                      />
                      <div className="font-size-22 m-b-30">
                        Harga di SIPLah tidak jauh berbeda dengan belanja{' '}
                        <i>offline</i>. Kita juga tinggal belanja tanpa pergi ke
                        toko jadi belanja lebih mudah.{' '}
                        <span className="bg-light-orange">
                          Bendahara senang karena dalam pelaporan tidak pusing
                        </span>{' '}
                        untuk pembayaran pajaknya. Barang yang dikirim pun
                        sesuai dengan yang dipesan.
                      </div>
                    </div>
                    <Row gutter={[16, 16]} className="align-items-center">
                      <Col
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        className="p-r-0 text-right"
                      >
                        <img
                          src="./assets/quotes/ava-satdik-3.jpeg"
                          alt="quotes"
                          className="img-quotes"
                        />
                      </Col>
                      <Col
                        lg={20}
                        md={18}
                        sm={18}
                        xs={18}
                        className="p-l-0 text-left"
                      >
                        <b>Eddyson Jassin</b>
                        <div className="grey-text">
                          <b>
                            Kepala Sekolah SMKN 2 Gorontalo Utara - Sulawesi
                            utara - Satuan Pendidikan
                          </b>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Slider>
            </div>
          </Container>
        </section>
        <section className="section-body-2">
          <Container>
            <h2 className="font-switzer-reguler m-b-64">
              <b>5 langkah berbelanja di SIPLah</b>
            </h2>
            <div className="d-none d-md-block d-lg-block d-xl-block align-items-center">
              <Row
                gutter={[16, 16]}
                className="m-t-50 m-b-30 align-items-start"
              >
                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className="sticky-md-top sticky-siplah"
                >
                  <img
                    src={getImage()}
                    alt="cara-kerja"
                    ref={imageRef}
                    className="img-semiblock"
                  />
                </Col>
                <Col lg={12} md={12} sm={24} xs={24}>
                  <div
                    className="width-step display-flex flex-column justify-content-center"
                    ref={firstContainer}
                  >
                    <div className="text-primary m-b-16 font-size-14">
                      <b>LANGKAH 1</b>
                    </div>
                    <h3 className="m-b-16">
                      <b>Satdik mencari dan memilih produk</b>
                    </h3>
                    <div className="grey-text font-size-16 text-justify">
                      Satdik bisa menggunakan fitur pencarian di situs SIPLah
                      atau langsung berbelanja ke situs masing-masing Mitra
                      pengelola pasar daring.
                    </div>
                  </div>
                  <div
                    className="width-step display-flex flex-column justify-content-center"
                    ref={secondContainer}
                  >
                    <div className="text-primary m-b-16 font-size-14">
                      <b>LANGKAH 2</b>
                    </div>
                    <h3 className="m-b-16">
                      <b>
                        Satdik membandingkan harga atau bernegosiasi ke Penyedia
                      </b>
                    </h3>
                    <div className="grey-text font-size-16 text-justify">
                      Sesuai peraturan yang berlaku, Satdik wajib membandingkan
                      produk di minimal 2 Penyedia (jika pembelanjaan di atas 50
                      juta), atau negosiasi harga ke Penyedia (jika pembelanjaan
                      di atas 223 juta).
                    </div>
                  </div>
                  <div
                    className="width-step display-flex flex-column justify-content-center"
                    ref={thirdContainer}
                  >
                    <div className="text-primary m-b-16 font-size-14">
                      <b>LANGKAH 3</b>
                    </div>
                    <h3 className="m-b-16">
                      <b>Satdik membuat pesanan</b>
                    </h3>
                    <div className="grey-text font-size-16 text-justify">
                      Setelah terjadi kesepakatan harga, waktu pengiriman, dan
                      termin pembayaran antara Satdik dan Penyedia, Mitra
                      pengelola pasar daring akan mengeluarkan surat pemesanan
                      sebagai tanda pesanan Satdik akan diproses.
                    </div>
                  </div>
                  <div
                    className="width-step display-flex flex-column justify-content-center"
                    ref={fourthContainer}
                  >
                    <div className="text-primary m-b-16 font-size-14">
                      <b>LANGKAH 4</b>
                    </div>
                    <h3 className="m-b-16">
                      <b>Satdik menerima pesanan</b>
                    </h3>
                    <div className="grey-text font-size-16 text-justify">
                      Satdik dapat melakukan komplain jika produk yang diterima
                      tidak sesuai spesifikasi. Jika tidak ada kendala, Satdik
                      mencetak Berita Acara Serah Terima (BAST) dan menerima
                      proforma <i>invoice</i> sebagai acuan pembayaran.
                    </div>
                  </div>
                  <div
                    className="width-step display-flex flex-column justify-content-center"
                    ref={fifthContainer}
                  >
                    <div className="text-primary m-b-16 font-size-14">
                      <b>LANGKAH 5</b>
                    </div>
                    <h3 className="m-b-16">
                      <b>Satdik melakukan pembayaran</b>
                    </h3>
                    <div className="grey-text font-size-16 text-justify">
                      Pembayaran dapat dilakukan melalui bank atau transfer ke{' '}
                      <i>virtual account</i> ke pihak Mitra pengelola pasar
                      daring. Setelah pembayaran terkonfirmasi, Satdik akan
                      menerima <i>invoice</i> final yang bisa digunakan sebagai
                      bukti potong pajak yang sah.
                    </div>
                  </div>
                  <br />
                </Col>
              </Row>
            </div>
            <div className="d-block d-sm-block d-md-none">
              <Row gutter={[16, 16]} className="m-t-30">
                <Col sm={24}>
                  <img
                    src="./assets/cara-kerja/img-satdik-mencari-dan-memilih.png"
                    alt="cara-kerja"
                    className="img-block "
                  />
                </Col>
                <Col sm={24}>
                  <div className="text-primary m-t-24 m-b-16 font-size-14">
                    <b>LANGKAH 1</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>Satdik mencari dan memilih produk</b>
                  </h3>
                  <div className="grey-text font-size-16 text-justify">
                    Satdik bisa menggunakan fitur pencarian di situs SIPLah atau
                    langsung berbelanja ke situs masing-masing Mitra pengelola
                    pasar daring.
                  </div>
                </Col>
              </Row>
              <br />
              <Row gutter={[16, 16]} className="m-t-30">
                <Col sm={24}>
                  <img
                    src="./assets/cara-kerja/img-satdik-membandingkan.png"
                    alt="cara-kerja"
                    className="img-block "
                  />
                </Col>
                <Col sm={24}>
                  <div className="text-primary m-t-24 m-b-16 font-size-14">
                    <b>LANGKAH 2</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>Satdik melakukan perbandingan harga atau negosiasi</b>
                  </h3>
                  <div className="grey-text font-size-16 text-justify">
                    Sesuai peraturan yang berlaku, untuk pembelanjaan di atas 50
                    juta, Satdik wajib membandingkan produk di minimal 2
                    Penyedia. Sedangkan untuk pembelanjaan di atas 223 juta,
                    Satdik harus melakukan negosiasi harga ke Penyedia.
                  </div>
                </Col>
              </Row>
              <br />
              <Row gutter={[16, 16]} className="m-t-30">
                <Col sm={24}>
                  <img
                    src="./assets/cara-kerja/img-satdik-membuat-pesanan.png"
                    alt="cara-kerja"
                    className="img-block "
                  />
                </Col>
                <Col sm={24}>
                  <div className="text-primary m-b-16 m-t-24 font-size-14">
                    <b>LANGKAH 3</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>Satdik membuat pesanan</b>
                  </h3>
                  <div className="grey-text font-size-16 text-justify">
                    Setelah terjadi kesepakatan harga, waktu pengiriman, dan
                    termin pembayaran, Satdik akan menerima invoice sementara
                    (proforma invoice) sebagai tanda pesanan Satdik akan
                    diproses Penyedia.
                  </div>
                </Col>
              </Row>
              <br />
              <Row gutter={[16, 16]} className="m-t-30">
                <Col sm={24}>
                  <img
                    src="./assets/cara-kerja/img-satdik-menerima-pesanan.png"
                    alt="cara-kerja"
                    className="img-block "
                  />
                </Col>
                <Col sm={24}>
                  <div className="text-primary m-b-16 m-t-24 font-size-14">
                    <b>LANGKAH 4</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>Satdik menerima pesanan</b>
                  </h3>
                  <div className="grey-text font-size-16 text-justify">
                    Satdik dapat melakukan komplain jika produk yang diterima
                    tidak sesuai dengan yang dipesan. Jika tidak ada kendala,
                    Satdik membuat Berita Acara Serah Terima (BAST) sebagai
                    konfirmasi.
                  </div>
                </Col>
              </Row>
              <br />
              <Row gutter={[16, 16]} className="m-t-30">
                <Col sm={24}>
                  <img
                    src="./assets/cara-kerja/img-satdik-melakukan-pembayaran.png"
                    alt="cara-kerja"
                    className="img-block "
                  />
                </Col>
                <Col sm={24}>
                  <div className="text-primary m-b-16 m-t-24 font-size-14">
                    <b>LANGKAH 5</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>Satdik melakukan pembayaran</b>
                  </h3>
                  <div className="grey-text font-size-16 text-justify">
                    Pembayaran dilakukan melalui transfer di bank atau virtual
                    account ke pihak Mitra. Setelah pembayaran terkonfirmasi,
                    Satdik akan menerima invoice final yang dapat digunakan
                    sebagai bukti potong pajak yang sah.
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
        <section className="section-body-4 bg-dark-blue">
          <Container>
            <h1 className="font-switzer-reguler m-b-24 text-white text-head-satdik">
              <b className="font-bolder">
                Yuk, mulai cari barang dan jasa di Mitra SIPLah!
              </b>
            </h1>
            <div className="text-white font-size-20 m-b-32 text-justify">
              <b>223.000+ Satdik</b> sudah terbantu oleh SIPLah. Sekarang
              saatnya Anda ikut merasakan kemudahan dalam pengadaan barang dan
              jasa.
            </div>
            <form onSubmit={onFormSubmit} className="form-search m-b-44">
              <InputGroup>
                <InputLeftAddon>
                  <span className="material-symbols-outlined font-size-20">
                    search
                  </span>
                </InputLeftAddon>
                <Input
                  placeholder="Contoh pencarian: buku matematika, papan tulis, tinta printer, jasa fotokopi..."
                  onChange={(e) => setKeyword(e.target.value)}
                  onClick={() => handleTypeSearchKeyword()}
                  value={keyword}
                  type="search"
                />
              </InputGroup>
              <Button
                color="blue"
                size="md"
                variant="solid"
                className="m-l-10 button-cari"
                type="submit"
              >
                Cari
              </Button>
            </form>
            <div className="m-b-24 text-white font-size-19">
              <b>Kategori paling dicari</b>
            </div>
            <Row gutter={[16, 16]} className="m-t-30 p-l-10 p-r-10">
              <Col lg={8} md={12} sm={24} xs={24} className="p-l-0 p-r-0">
                <a
                  className="category why-use-siplah align-items-center text-center box-nine-1"
                  onClick={() => searchItem('Alat Tulis Kantor')}
                >
                  <Row gutter={[16, 16]} className="align-items-center">
                    <Col lg={4} md={4} sm={6} xs={6}>
                      <img
                        src="./assets/homepage/atk.png"
                        alt="kategori"
                        className="img-category"
                      />
                    </Col>
                    <Col lg={16} md={16} sm={14} xs={14} className="text-left">
                      <b>Alat tulis kantor</b>
                      <div className="grey-text">Terjual 3jt produk</div>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4} className="text-right">
                      <span className="material-symbols-outlined category-arrow">
                        arrow_forward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
              <Col lg={8} md={12} sm={24} xs={24} className="p-l-0 p-r-0">
                <a
                  className="category why-use-siplah align-items-center text-center box-nine-2"
                  onClick={() => searchItem('Elektronik')}
                >
                  <Row gutter={[16, 16]} className="align-items-center">
                    <Col lg={4} md={4} sm={6} xs={6}>
                      <img
                        src="./assets/homepage/elektronik.png"
                        alt="kategori"
                        className="img-category"
                      />
                    </Col>
                    <Col lg={16} md={16} sm={14} xs={14} className="text-left">
                      <b>Elektronik</b>
                      <div className="grey-text">Terjual 2jt produk</div>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4} className="text-right">
                      <span className="material-symbols-outlined category-arrow">
                        arrow_forward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
              <Col lg={8} md={12} sm={24} xs={24} className="p-l-0 p-r-0">
                <a
                  className="category why-use-siplah align-items-center text-center box-nine-3"
                  onClick={() => searchItem('Alat peraga sekolah')}
                >
                  <Row gutter={[16, 16]} className="align-items-center">
                    <Col lg={4} md={4} sm={6} xs={6}>
                      <img
                        src="./assets/homepage/alat-peraga.png"
                        alt="kategori"
                        className="img-category"
                      />
                    </Col>
                    <Col lg={16} md={16} sm={14} xs={14} className="text-left">
                      <b>Alat peraga sekolah</b>
                      <div className="grey-text">Terjual 1jt produk</div>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4} className="text-right">
                      <span className="material-symbols-outlined category-arrow">
                        arrow_forward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
              <Col lg={8} md={12} sm={24} xs={24} className="p-l-0 p-r-0">
                <a
                  className="category why-use-siplah align-items-center text-center box-nine-4"
                  onClick={() => searchItem('Rumah tangga')}
                >
                  <Row gutter={[16, 16]} className="align-items-center">
                    <Col lg={4} md={4} sm={6} xs={6}>
                      <img
                        src="./assets/homepage/rumah-tangga.png"
                        alt="kategori"
                        className="img-category"
                      />
                    </Col>
                    <Col lg={16} md={16} sm={14} xs={14} className="text-left">
                      <b>Rumah tangga</b>
                      <div className="grey-text">Terjual 1jt produk</div>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4} className="text-right">
                      <span className="material-symbols-outlined category-arrow">
                        arrow_forward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
              <Col lg={8} md={12} sm={24} xs={24} className="p-l-0 p-r-0">
                <a
                  className="category why-use-siplah align-items-center text-center box-nine-5"
                  onClick={() => searchItem('Buku')}
                >
                  <Row gutter={[16, 16]} className="align-items-center">
                    <Col lg={4} md={4} sm={6} xs={6}>
                      <img
                        src="./assets/homepage/buku.png"
                        alt="kategori"
                        className="img-category"
                      />
                    </Col>
                    <Col lg={16} md={16} sm={14} xs={14} className="text-left">
                      <b>Buku</b>
                      <div className="grey-text">Terjual 800rb produk</div>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4} className="text-right">
                      <span className="material-symbols-outlined category-arrow">
                        arrow_forward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
              <Col lg={8} md={12} sm={24} xs={24} className="p-l-0 p-r-0">
                <a
                  className="category why-use-siplah align-items-center text-center box-nine-6"
                  onClick={() => searchItem('Kesehatan')}
                >
                  <Row gutter={[16, 16]} className="align-items-center">
                    <Col lg={4} md={4} sm={6} xs={6}>
                      <img
                        src="./assets/homepage/kesehatan.png"
                        alt="kategori"
                        className="img-category"
                      />
                    </Col>
                    <Col lg={16} md={16} sm={14} xs={14} className="text-left">
                      <b>Kesehatan</b>
                      <div className="grey-text">Terjual 500rb produk</div>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4} className="text-right">
                      <span className="material-symbols-outlined category-arrow">
                        arrow_forward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
              <Col lg={8} md={12} sm={24} xs={24} className="p-l-0 p-r-0">
                <a
                  className="category why-use-siplah align-items-center text-center box-nine-7"
                  onClick={() => searchItem('Pertukangan')}
                >
                  <Row gutter={[16, 16]} className="align-items-center">
                    <Col lg={4} md={4} sm={6} xs={6}>
                      <img
                        src="./assets/homepage/pertukangan.png"
                        alt="kategori"
                        className="img-category"
                      />
                    </Col>
                    <Col lg={16} md={16} sm={14} xs={14} className="text-left">
                      <b>Pertukangan</b>
                      <div className="grey-text">Terjual 400rb produk</div>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4} className="text-right">
                      <span className="material-symbols-outlined category-arrow">
                        arrow_forward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
              <Col lg={8} md={12} sm={24} xs={24} className="p-l-0 p-r-0">
                <a
                  className="category why-use-siplah align-items-center text-center box-nine-8"
                  onClick={() => searchItem('Jasa cetak')}
                >
                  <Row gutter={[16, 16]} className="align-items-center">
                    <Col lg={4} md={4} sm={6} xs={6}>
                      <img
                        src="./assets/homepage/jasa-cetak.png"
                        alt="kategori"
                        className="img-category"
                      />
                    </Col>
                    <Col lg={16} md={16} sm={14} xs={14} className="text-left">
                      <b>Jasa cetak</b>
                      <div className="grey-text">Terjual 300rb produk</div>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4} className="text-right">
                      <span className="material-symbols-outlined category-arrow">
                        arrow_forward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
              <Col lg={8} md={12} sm={24} xs={24} className="p-l-0 p-r-0">
                <a
                  className="category why-use-siplah align-items-center text-center box-nine-9"
                  onClick={() => searchItem('Makanan dan minuman')}
                >
                  <Row className="align-items-center">
                    <Col lg={4} md={4} sm={6} xs={6}>
                      <img
                        src="./assets/homepage/makanan.png"
                        alt="kategori"
                        className="img-category"
                      />
                    </Col>
                    <Col lg={16} md={16} sm={14} xs={14} className="text-left">
                      <b>Makanan & minuman</b>
                      <div className="grey-text">Terjual 300rb produk</div>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4} className="text-right">
                      <span className="material-symbols-outlined category-arrow">
                        arrow_forward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
              <Col
                lg={8}
                md={12}
                sm={24}
                xs={24}
                className="p-l-0 p-r-0 d-none d-md-block d-lg-none"
              >
                <div className="why-use-siplah align-items-center text-center box-nine-10"></div>
              </Col>
            </Row>
          </Container>
        </section>
        <br />
        <section className="section-pertanyaan-umum bg-white-smoke">
          <Container>
            <h2 className="font-switzer-reguler gap-text-header-64">
              <b>Pertanyaan umum seputar berbelanja di SIPLah</b>
            </h2>
            {collapse.map((data, i) => (
              <Collapsible
                defaultOpen={data.open}
                key={i}
                onClick={() => changeCollapse(data.id)}
              >
                <CollapsibleTrigger
                  className={`bg-white text-left p-b-12 collapse-siplah ${
                    data.id == 1
                      ? 'collapse-first'
                      : data.id == 5
                      ? 'collapse-last'
                      : ''
                  }`}
                >
                  <span className="font-size-19 text-left">{data.title}</span>{' '}
                  <CollapsibleIcon />
                </CollapsibleTrigger>
                <CollapsibleContent>
                  <div
                    className={`grey-text p-l-20 p-r-30 p-b-20 font-size-16 bg-white ${
                      data.id == 5 ? 'collapse-last' : ''
                    }`}
                    dangerouslySetInnerHTML={{ __html: data.content }}
                  />
                </CollapsibleContent>
              </Collapsible>
            ))}
            <div className="m-t-44">
              Punya pertanyaan lain? Kunjungi halaman{' '}
              <a
                href="https://pusatinformasi.siplah.kemendikdasmen.go.id/hc/articles/7007479512985-Fitur-Pencarian-pada-SIPLah"
                className="primary-blue text-underline"
                target="_blank"
                onClick={() => handleClickHelpCenter()}
              >
                Pusat Bantuan SIPLah
              </a>
            </div>
          </Container>
        </section>
        <div className="display-flex overflow-x-hidden">
          <span className="line-upper-footer bg-blue" />
          <span className="line-upper-footer bg-orange" />
          <span className="line-upper-footer bg-green" />
          <span className="line-upper-footer bg-pink" />
        </div>
      </div>
      <Modal
        show={isVideoOpen}
        onHide={() => setIsVideoOpen(false)}
        className="modal-video"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="align-right">
          <a onClick={() => setIsVideoOpen(false)}>
            <span className="material-symbols-outlined text-white font-size-20">
              close
            </span>
          </a>
        </Modal.Header>
        <div className="video-container">
          <iframe
            src="https://www.youtube.com/embed/zoBwhidWWjE?autoplay=1"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            width="800"
            height="449"
            title="video"
          />
        </div>
      </Modal>
    </>
  )
}
export default SatuanPendidikans
